import $ from 'jquery';
import { MediaQueries } from 'Util/mediaqueries';
import { Popup } from 'App/popup/popup';
import { publish, unpublish, subscribe, unsubscribe } from 'Util/pubsub';

var $window;
var $page;
var pagePos;
var $shareLinks;

var SocialShare = {
	init: function () {
		SocialShare = this;
		$window = $(window);
		$page = $('.js-page');
		pagePos = $page.offset().top;
		$shareLinks = $('.js-share');

		MediaQueries.register([
			{
				queries: MediaQueries.queries['share-floating'],
				shouldDegrade: true,
				match: function () {
					SocialShare._floatingShareSetup();
					subscribe('/window/scroll', SocialShare._onScroll);
				},
				unmatch: function () {
					unsubscribe('/window/scroll', SocialShare._onScroll);
				}
			}
		]);

		SocialShare._initEvents();
	},

	_initEvents: function () {
		$('.js-social-popup').on('click', this._processClick);
	},

	_floatingShareSetup: function () {
		if ($page.height() > $window.height()) {
			$shareLinks.addClass('c-share--floating');
		}
	},

	_onScroll: function () {
		var newTopPos = $window.scrollTop();

		if (newTopPos > pagePos) {
			$shareLinks.addClass('is-visible');
		}
	},

	_processClick: function (event) {
		event.preventDefault();
		var $thisLink = $(this);
		var width = $thisLink.attr('data-social-width') ? $thisLink.attr('data-social-width') : 550;
		var height = $thisLink.attr('data-social-height') ? $thisLink.attr('data-social-height') : 450;

		Popup.open(this.href, width, height);
	}
};

export { SocialShare };